import { useMutation } from '@tanstack/react-query';
import { api } from '@/core/api/client';

export function useChangePassword() {
  return useMutation({
    mutationFn: (body: { current_password: string; new_password: string }) =>
      api.post('/auth/password/change', body),
  });
}
